import { render, staticRenderFns } from "./AvatarCom.vue?vue&type=template&id=2ff52fe6&scoped=true"
import script from "./AvatarCom.vue?vue&type=script&lang=js"
export * from "./AvatarCom.vue?vue&type=script&lang=js"
import style0 from "./AvatarCom.vue?vue&type=style&index=0&id=2ff52fe6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ff52fe6",
  null
  
)

export default component.exports